import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'react-calendar/dist/Calendar.css';
import Ustudyhigslide from './Ustudyhigslide';
import Testimonial from '../../../Components/UEFoot/Testimonial';
import UstudyTabs from './UstudyTabs';
import EnquirePopupFrom from '../../../Components/EnquirePopupFrom';
import TalktoExpert from '../TalktoExpert';
import BookaDemo from '../BookaDemo';
import './ustudy.css';

const Ustudy = () => {
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <div className="ustudyPage">
            <section className='InnerPBanSec'>
                <div className='IPBBgimg'>
                    <img src={require('../../../asstes/images/ustudyBanBg.jpg')} alt="" />
                </div>
                <div className='BanContSec'>
                    <Container>
                        <div className='textBlack'>
                            <h5 className='textright tbheadFive tbHeadLeft'>Bridging learning  <br />beyond borders through</h5>
                            <h1>Ustudy</h1>
                            <h5 className='tbheadFive tbHeadRight'>A Global E-Learning Solutions for  Collaborative Experience</h5>
                        </div>
                    </Container>
                </div>
            </section>
            <section className='ProIntroSec'>
                <div className='ProContSec UstdyIntroC'>
                    <Container>
                        <div className='textBlack tbTitle'>
                            <h2 data-aos="fade-down" data-aos-duration="1000">Introducing <span>Ustudy</span></h2>
                            <h4 data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">An e-learning platform that facilitates a collaborative</h4>
                            <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="200">teaching and learning experience, leading to a personalized learning journey. Engineered to revolutionize the learning <br />
                                platform, through empowering individuals on their unique learning journey. As a pioneer we take a new approach to transform <br />
                                education, making it universally accessible and of uncompromised quality. USTUDY empowers individuals to curate their <br />
                                educational path, aligning courses with their passions. Geared towards an inventive work-study approach, <br />
                                enriching academic learning through practical engagement. Collaborative alliances between <br />
                                educational institutions and businesses furnish students with invaluable <br />
                                educational experience.</p>
                        </div>
                        <div className='textBlack ktbkList'>
                            <ul>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="300"><img src={require('../../../asstes/images/customizablelearningpaths.svg').default} alt="customizable learning paths" /><strong>Customizable
                                    <br /> Learning Paths </strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="400"><img src={require('../../../asstes/images/ExpertDrivenResources.svg').default} alt="Expert Driven Resources" /><strong>Expert-Driven
                                    <br /> Resources</strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="500"><img src={require('../../../asstes/images/DynamicTimetabling.svg').default} alt="Dynamic Timetabling" /><strong>Dynamic
                                    <br /> Timetabling</strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="700"><img src={require('../../../asstes/images/ComprehensiveE-LearningModule.svg').default} alt="Comprehensive E-Learning Module" /><strong>Comprehensive

                                    <br /> E-Learning Module</strong></li>
                            </ul>
                            <ul>

                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="600"><img src={require('../../../asstes/images/GlobalLearningCommunity.svg').default} alt="Global Learning
Community"/><strong>Global Learning
                                        <br /> Community</strong></li>
                                <li data-aos="fade-down" data-aos-duration="1000" data-aos-delay="600"><img src={require('../../../asstes/images/WorkStudymodel.svg').default} alt="Work-Study model" /><strong>Work-Study<br /> model</strong></li>
                            </ul>
                        </div>
                    </Container>
                </div>
            </section>
            <section className='ProAIPowSec ustudyHigl'>
                <Container>
                    <Row>
                        <Col md={5} className='ProAIPowSCol ustudyHiglLeft'>
                            <div className='ProAIPowIMg'><img src={require('../../../asstes/images/ustudy-w-img.png')} alt="Kadbook's AI-Powered" /></div>
                        </Col>

                        <Col md={7} className='ProAIPowSCol ustudyHiglRight'>
                            <div className='textBlack tbTitle'>
                                <h2 data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">Ustudy Highlights </h2>
                                <h4 data-aos="fade-down" data-aos-duration="1000">Hand-on Features for an Online <br />
                                    Learning Experience   </h4>
                                <p data-aos="fade-down" data-aos-duration="1000">USTUDY comes equipped with an assortment of features that facilitates
                                    an enhanced education experience.</p>
                            </div>
                            <Ustudyhigslide />

                        </Col>
                    </Row>
                </Container>
            </section>
            <section className='Ulearn' style={{ padding: '50px 0', backgroundColor: '#f9fbfd' }}>
                <Container>

                    <div className='UlearnTitle' style={{ textAlign: 'center', marginBottom: '10px' }}>
                        <h2 style={{ fontWeight: '800', letterSpacing: '1px', fontFamily: 'halyard_textblack', fontSize: '45px' }}>
                            <span data-aos="fade-down" data-aos-duration="1000" style={{ color: '#3ab2cb', display: 'inline-block' }}>USTUDY</span>
                            <span data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100" style={{ color: '#1a1a1a', display: 'inline-block' }}> - KAcademy</span>
                        </h2>
                    </div>

                    <Row className="justify-content-center" style={{ marginBottom: '20px' }}>
                        <Col lg={9} md={12}>
                            <div style={{ backgroundColor: '#ffffff', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', border: '1px solid #eef2f5' }}>
                                <p style={{ textAlign: 'center', color: '#4a5568', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '16px' }}>
                                    UStudy KAcademy is a next-generation learning academy designed to strengthen academic performance in board examinations and enhance preparedness for competitive entrance exams such as <span style={{ color: "#000", fontWeight: "700" }}>NEET</span> and <span style={{ color: "#000", fontWeight: "700" }}>JEE</span>.
                                </p>
                                <p style={{ textAlign: 'center', color: '#4a5568', fontSize: '1.1rem', lineHeight: '1.8', margin: 0 }}>
                                    The program offers <span style={{ color: "#1a1a1a", fontWeight: "600" }}>Self-Learning, AI-Assisted Learning,</span> and <span style={{ color: "#1a1a1a", fontWeight: "600" }}>Learning with Expert Tutors,</span> supported by enhanced learning content in KADBOOK format, to deliver a result-oriented and effective learning experience.
                                </p>
                            </div>
                        </Col>
                    </Row>


                    <Row className="g-4" style={{ marginBottom: '40px' }}>
                        <Col md={6}>
                            <div className='UlearnCard' style={{ height: '100%' }}>
                                <h4 style={{ color: '#1a1a1a', fontWeight: '700', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ color: '#3ab2cb' }}>✦</span> KAcademy Offers
                                </h4>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    {["Standard 6 to 12 – For academic excellence", "Standard 6 to 8 – JEE Foundation program", "Standard 9 to 12 – JEE Main & JEE Advanced preparation", "Standard 6 to 8 – NEET Foundation program", "Standard 9 to 12 – NEET preparation", "Standard 10 & 12 – For Academic Programs under NIOS"].map((item, idx) => (
                                        <div key={idx} className='UlearnOfferCard' style={{ display: 'flex', alignItems: 'center', gap: '18px', background: '#fff', borderRadius: '10px', padding: '16px 20px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1px solid #eef2f5' }}>
                                            <span style={{ flex: '0 0 auto', width: '46px', height: '46px', borderRadius: '50%', background: 'rgba(58,178,203,0.1)', color: '#3ab2cb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', fontWeight: 'bold' }}>✓</span>
                                            <strong style={{ fontSize: '16px', lineHeight: '1.3', letterSpacing: '-0.3px', color: '#1a1a1a', fontWeight: '600' }}>{item}</strong>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className='UlearnCard' style={{ background: '#fff', padding: '30px', borderRadius: '16px', height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.02)', border: '1px solid #eef2f5' }}>
                                <h4 style={{ color: '#1a1a1a', fontWeight: '700', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ color: '#3ab2cb' }}>✦</span> Features Provided in KADBOOK Format
                                </h4>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                    {["Notes", "Bookmarks", "Hyperlinks", "Highlights", "RAG AI & Generative AI", "Read Aloud (TTS)", "DET - Dictionary, Encyclopedia,  Translator ."].map((item, idx) => (
                                        <div key={idx} style={{ background: '#f7fafc', padding: '12px 16px', borderRadius: '8px', color: '#4a5568', fontWeight: '500', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ color: '#3ab2cb', fontWeight: 'bold' }}>0{idx + 1}.</span> {item}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        <Col lg={6} md={12}>
                            <div className='UlearnCard' style={{ background: '#fff', padding: '30px', borderRadius: '16px', height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.02)', border: '1px solid #eef2f5' }}>
                                <h4 style={{ color: '#1a1a1a', fontWeight: '700', marginBottom: '20px' }}>
                                    KAcademy’s Enhanced Learning Content Consists of
                                </h4>
                                <ul style={{ listStyle: 'none', paddingLeft: 0, margin: 0, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                    {["Detailed Keywords", "2D & 3D Videos", "Explanation Videos", "3D Models", "Audio Reader", "Q & A Solutions", "Adaptive Assessments", "Solved PYQs", "Topic Synopsis", "Mock Exams", "Interactive Activities", "Virtual Lab"].map((item, idx) => (
                                        <li key={idx} style={{ padding: '8px 12px', background: '#f8fafc', borderRadius: '6px', fontSize: '0.9rem', color: '#4a5568', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <span style={{ color: '#3ab2cb' }}>•</span> {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>

                        <Col lg={6} md={12}>
                            <div className='UlearnCard' style={{ background: '#fff', padding: '30px', borderRadius: '16px', height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.02)', border: '1px solid #eef2f5' }}>
                                <h4 style={{ color: '#1a1a1a', fontWeight: '700', marginBottom: '45px' }}>
                                    Learning Modes Offered
                                </h4>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '50px' }}>

                                    <div style={{ borderLeft: '3px solid #3ab2cb', paddingLeft: '15px' }}>
                                        <h6 style={{ fontWeight: '700', color: '#1a1a1a', margin: '0 0 5px 0' }}>Self-Learning</h6>
                                        <p style={{ margin: 0, fontSize: '0.9rem', color: '#718096' }}>Pre-planned timetable • Learn at own pace • Insights & Mock tests</p>
                                    </div>

                                    <div style={{ borderLeft: '3px solid #3ab2cb', paddingLeft: '15px' }}>
                                        <h6 style={{ fontWeight: '700', color: '#1a1a1a', margin: '0 0 5px 0' }}>Learning with AI Assistance</h6>
                                        <p style={{ margin: 0, fontSize: '0.9rem', color: '#718096' }}>24/7 Academic bot • Instant doubt resolution • Adaptive assessment support</p>
                                    </div>

                                    <div style={{ borderLeft: '3px solid #3ab2cb', paddingLeft: '15px' }}>
                                        <h6 style={{ fontWeight: '700', color: '#1a1a1a', margin: '0 0 5px 0' }}>Learning with Expert Tutors</h6>
                                        <p style={{ margin: 0, fontSize: '0.9rem', color: '#718096' }}>Live classes • Dedicated 24/7 tutor clarification • Personalized mentoring</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className='ProRobSolSec KampusRobSolSec ustudyRed'>
                <div className='RobSolSlides'>
                    <div className={`RobSolSlide RSSlideOne`}  >
                        <Container>
                            <Row>
                                <Col md={12} >
                                    <div className='textBlack tbTitle titlemBtm'>
                                        <h2 data-aos="fade-down" data-aos-duration="1000"><span>USTUDY</span> for Corporates Redefines Learning to the Industry’s Standard  </h2>
                                        <h5 data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">Bespoke Learning to Elevate Workforce Excellence </h5>
                                    </div>
                                </Col>
                                <Col md={5} className='ProRobRcol'>
                                    <div className='RobSolItems'>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/EfficientDataManagement.svg').default} alt="Efficient Data Management" />
                                            <h4>Efficient Data <br />Management</h4>
                                            <p>Streamline tasks & <br /> manage  employee <br />training data.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/SeamlessERPIntegration.svg').default} alt="Seamless ERP Integration" />
                                            <h4>Seamless ERP <br />Integration </h4>
                                            <p>Training aligns with <br /> organizational <br /> processes.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/SecureCommunication.svg').default} alt="Secure Communication" />
                                            <h4>Secure <br /> Communication <br /> Channels</h4>
                                            <p>Collaboration with <br /> trainers, management, <br /> and learners.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/Role-BasedDashboards.svg').default} alt="Role-Based Dashboards" />
                                            <h4>Role-Based <br /> Dashboards</h4>
                                            <p>Tailored access to <br /> different groups for <br /> management.</p>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={7} className='ProRobLcol'>
                                    <img src={require('../../../asstes/images/Ustudy-Redefines-img.jpg')} alt="Robust Solutions " />

                                </Col >
                                <Col md={12} className='ProRobBtmcol'>
                                    <div className='RobSolItems'>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/ExpertWebinars.svg').default} alt="Expert Webinars" />
                                            <h4>Expert <br />  Webinars</h4>
                                            <p>Industry-specific <br /> insights from experts.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/CustomizableLearningPath.svg').default} alt="Customizable Learning Path" />
                                            <h4>Customizable  <br /> Learning Paths</h4>
                                            <p>Designed programs for <br /> employee development.</p>
                                        </div>
                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/TimeProgressTracking.svg').default} alt="Real-Time Progress Tracking" />
                                            <h4>Real-Time Progress <br /> Tracking</h4>
                                            <p>Monitoring for targeted <br /> training interventions.</p>
                                        </div>

                                        <div className='RobSolItem'>
                                            <img src={require('../../../asstes/images/KBRobSolIcon10.svg').default} alt="Flexible Learning Environments" />
                                            <h4>Flexible Learning <br /> Environments</h4>
                                            <p>Adapt to flexibility modern  <br /> workplaces demand.</p>
                                        </div>
                                    </div>
                                </Col >
                            </Row>
                        </Container>
                    </div>

                </div>
            </section>
            <section className='ProApplinkSec'>
                <Container>
                    <div className='textBlack tbTitle'>
                        <h4 data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">Get your <br /><span className='colorchange'>K</span>ollaborative <br /><span className='colorchange'>A</span>dvanced <br /><span className='colorchange'>T</span>ext<span className='colorchange'>book</span> NOW!</h4>
                        <ul data-aos="fade-right" data-aos-duration="1000" data-aos-delay="100">
                            <li><Link to='https://www.katbookstore.com/' target='_blank'><img src={require('../../../asstes/images/digital-katebook-img.png')} alt="digital-katebook-img" /></Link></li>
                            <li><Link to='#'><img src={require('../../../asstes/images/GPlayImg.webp')} alt="Google Play" /></Link></li>
                            <li><Link to='#'><img src={require('../../../asstes/images/AppStoreImg.webp')} alt="App Store" /></Link></li>
                        </ul>
                    </div>
                    <div className='applinkdiv'><img src={require('../../../asstes/images/proAppLinkImg.png')} alt="App Link" /></div>
                </Container>
            </section>



            <section className='WChoKBSec WChoKmpsSec'>
                <Container>
                    <div className='textBlack tbTitle textCenter titlemBtm'>
                        <h2 data-aos="fade-down" data-aos-duration="1000">Why <span>USTUDY</span> is a </h2>
                        <h4 data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">better option? Empowering Your Workforce</h4>
                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="200">Creating a culture of learning and development means providing employees with<br /> the opportunity to learn new skills and knowledge.</p>
                    </div>
                    <div className='WCHooTab'>
                        <UstudyTabs />
                    </div>
                </Container>
            </section>
            {/* <section className='HoldonSec'>
                <Container>
                    <div className='textBlack tbTitle textCenter titlemBtm'>
                        <h2 data-aos="fade-down" data-aos-duration="1000"><span>Hold On</span></h2>
                        <p data-aos="fade-down" data-aos-duration="1000" data-aos-delay="100">did you try our demo ?</p>
                    </div>
                    <div className='honInROw'>
                        <Row>
                            <Col md='6' className='honCol honColL'>
                                <div className='HoFromCont'>
                                    <h4>Talk To An Expert</h4>
                                    <TalktoExpert />
                                </div>
                            </Col>
                            <Col md='6' className='honCol honColR'>
                                <div className='HoCalen'>
                                    <BookaDemo />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section> */}
            <Testimonial />
            <EnquirePopupFrom show={modalShow} onHide={() => setModalShow(false)} />
        </div>
    )
}



export default Ustudy